import * as React from "react"

function SvgComponent(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={38}
      height={36.208}
      viewBox="0 0 38 36.208"
      {...props}
    >
      <defs>
        <clipPath id="prefix__a">
          <path
            data-name="Path 7406"
            d="M0 0h25.181v25.157H0zm0 0"
            fill="#fffdf5"
          />
        </clipPath>
      </defs>
      <g data-name="Component 42 \u2013 1">
        <g
          data-name="Group 318"
          clipPath="url(#prefix__a)"
          transform="translate(7.263 11.051)"
        >
          <path
            data-name="Path 7405"
            d="M17.941 15.568h1.6v-5.486h-1.6zm-4.723 0h1.264a1.612 1.612 0 00.382-.1 1.9 1.9 0 00.716-.512 2.365 2.365 0 00.549-1.224v-1.3a1.027 1.027 0 01.1-.331.465.465 0 01.31-.1h.907v-1.944h-.907a1.915 1.915 0 00-1.36.6 2.172 2.172 0 00-.6 1.233v1.384a2.237 2.237 0 01-.048.377.215.215 0 01-.191.126h-1.122zm-2.076 0h1.622v-5.536h-1.622zm-2.1-2.185a1.277 1.277 0 01-.071.332.319.319 0 01-.215.126l-.954.027v1.7h1.336a1.144 1.144 0 00.334-.05 1.526 1.526 0 00.668-.407 2.079 2.079 0 00.525-1.043v-4.011l-1.622-.025zm-3.315 2.185h1.6v-5.536h-1.6zM18.108 1.176a9.569 9.569 0 011.622.3 5.712 5.712 0 012.159 1.3 6.982 6.982 0 011.4 1.748 4.932 4.932 0 01.62 2.189l-5.32.025-.024 2.063a16.3 16.3 0 011.646.554 5.584 5.584 0 011.718 1.208q.119.126.382.377a6.792 6.792 0 011.336 2.365 5.811 5.811 0 01.239 1.157l-.029 9.406H6.502a12.664 12.664 0 01-1.809-.377 6.161 6.161 0 01-2.143-1.283 3.482 3.482 0 01-1.308-2.465q0-.428.024-.78h5.463v-2.264a13.129 13.129 0 01-1.741-.352 5.99 5.99 0 01-1.814-.979 5.2 5.2 0 01-1.241-1.308 4.786 4.786 0 01-.692-1.736l.072-11.2zM.025 11.843a4.437 4.437 0 00.191 1.082 6.642 6.642 0 001.407 2.491 7.016 7.016 0 003.626 2.264H.002v1.388a16.579 16.579 0 00.453 2.26 5.882 5.882 0 001.527 1.963 7.286 7.286 0 002.135 1.271 6.416 6.416 0 002.4.541l18.607.051V14.611a12.756 12.756 0 00-.31-1.51 8.289 8.289 0 00-3.005-4.327 5.267 5.267 0 00-1.5-.805h4.843a7.61 7.61 0 00-1.837-5.434A7.225 7.225 0 0020.827.568a6.163 6.163 0 00-2.338-.554L.097-.006zm0 0"
            fill="#fffdf5"
            fillRule="evenodd"
          />
        </g>
        <text
          data-name="\u0627\u0633\u062A\u0627\u0646\u062F\u0627\u0631\u062F \u0627\u06CC\u0631\u0627\u0646"
          transform="translate(19 7)"
          fill="#fff"
          fontSize={6}
          fontFamily="IRANYekanFN-Medium, IRANYekanFN"
          fontWeight={500}
        >
          <tspan x={18.113} y={0}>
            {
              "\u0627\u0633\u062A\u0627\u0646\u062F\u0627\u0631\u062F \u0627\u06CC\u0631\u0627\u0646"
            }
          </tspan>
        </text>
      </g>
    </svg>
  )
}

const MemoSvgComponent = React.memo(SvgComponent)
export default MemoSvgComponent
